
export const CALENDARIO_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full bg-gradient-to-br from-gray-50 via-violet-50/30 to-gray-50 animate-in fade-in slide-in-from-bottom-4 duration-500",
    },
    header: {
        container: "sticky top-0 z-20 bg-white/70 backdrop-blur-xl border-b border-violet-100/40 px-6 py-3 shadow-sm shadow-violet-500/5",
        row: "flex items-center justify-between gap-4",
        left: "flex items-center gap-3",
        center: "flex items-center gap-3",
        right: "flex items-center gap-2",
        iconBox: "w-10 h-10 rounded-2xl bg-gradient-to-br from-violet-100 to-violet-50 flex items-center justify-center shadow-sm shadow-violet-200/50",
        title: "text-lg font-bold text-gray-900 tracking-tight",
        calendarSelect: {
            trigger: "w-[200px] bg-white/80 h-9 px-3 text-sm font-medium text-gray-700 border-violet-100 hover:bg-violet-50/50 hover:border-violet-200 focus:ring-[#7C3AED]/20 rounded-xl transition-all",
            content: "bg-white rounded-xl shadow-xl shadow-violet-500/10 border border-violet-100 mt-1",
            item: "px-3 py-2 text-sm text-gray-700 hover:bg-violet-50 hover:text-violet-700 cursor-pointer transition-colors",
        },
        viewToggle: {
            container: "flex bg-gray-100/80 p-1 rounded-xl gap-0.5",
            button: "h-8 px-3 text-xs font-medium rounded-lg transition-all duration-200 flex items-center gap-1.5",
            active: "bg-white shadow-sm shadow-violet-500/10 text-violet-700",
            inactive: "text-gray-500 hover:text-gray-700 hover:bg-white/50",
        },
        nav: {
            container: "flex items-center gap-1",
            button: "h-8 w-8 flex items-center justify-center rounded-xl text-gray-500 hover:bg-violet-50 hover:text-violet-600 transition-all",
            dateLabel: "text-sm font-semibold text-gray-900 min-w-[140px] text-center",
        },
        createButton: "flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#7C3AED] to-[#6D28D9] hover:from-[#6D28D9] hover:to-[#5B21B6] text-white text-sm font-medium rounded-xl transition-all shadow-md shadow-[#7C3AED]/25 active:transform active:scale-95 hover:shadow-lg hover:shadow-[#7C3AED]/30",
        todayButton: "h-9 px-3 text-sm font-medium text-violet-600 border border-violet-200 rounded-xl hover:bg-violet-50 hover:border-violet-300 transition-all",
    },
    content: {
        container: "flex-1 flex overflow-hidden",
        calendarArea: "flex-1 p-4 overflow-auto",
        calendarWrapper: "bg-white rounded-2xl border border-gray-100/80 overflow-hidden shadow-sm shadow-violet-500/5 ring-1 ring-gray-900/[0.02]",
    },
    sidebar: {
        container: "w-[280px] border-l border-violet-100/50 bg-gradient-to-b from-gray-50/80 via-white to-violet-50/30 flex flex-col overflow-hidden",
        header: "p-4 border-b border-violet-100/40 bg-gradient-to-r from-violet-50/60 to-transparent",
        headerTitle: "text-xs font-bold uppercase tracking-wider text-violet-500",
        body: "flex-1 overflow-y-auto p-2",
        dateGroup: "flex flex-col gap-3",
        dateDot: "h-2 w-2 rounded-full bg-gradient-to-br from-violet-400 to-violet-500 shadow-sm shadow-violet-300",
        dateLabel: "text-xs font-semibold text-violet-500/80 uppercase",
        dateLine: "h-px flex-1 bg-gradient-to-r from-violet-100 to-transparent",
    },
    eventCard: {
        container: "group relative flex flex-col gap-1.5 p-3 rounded-xl border border-violet-100/60 bg-white/80 hover:bg-violet-50 hover:border-violet-200 hover:shadow-md hover:shadow-violet-500/10 transition-all duration-200 cursor-pointer",
        time: "text-[10px] font-bold text-violet-600 min-w-fit",
        divider: "h-4 w-px bg-violet-200/60",
        title: "text-xs font-medium text-gray-700 group-hover:text-violet-800 truncate transition-colors",
    },
    eventContent: {
        lais: "bg-violet-50/60 border-violet-100/50 flex flex-row rounded-md p-1 gap-2 border h-full",
        external: "bg-blue-50/40 border-blue-100/50 flex flex-row rounded-md p-1 gap-2 border h-full",
        laisText: "text-violet-600",
        externalText: "text-blue-600",
        timeText: "text-[10px] font-semibold",
        titleText: "text-[10px] font-medium",
    },
    dialog: {
        content: "min-w-[900px]",
        divider: "border-t border-dashed border-violet-100",
        section: "space-y-4 p-4 flex flex-col gap-2",
        tabGroup: "flex bg-gray-100/80 p-1 rounded-xl w-max",
        tabActive: "px-4 py-1.5 rounded-lg text-sm bg-gradient-to-r from-violet-500 to-violet-600 text-white font-semibold shadow-sm shadow-violet-500/25",
        tabInactive: "px-4 py-1.5 rounded-lg text-sm text-gray-500 hover:text-violet-600 hover:bg-violet-50/50 transition-colors",
        label: "text-sm text-gray-600",
        timeInput: "border px-2 h-8 rounded-lg mt-1.5 w-full bg-gray-50 border-gray-200 focus:border-violet-300 focus:ring-violet-200/50 transition-colors",
        footer: "flex justify-end space-x-2 mt-2",
    },
    colorPicker: {
        container: "flex flex-col gap-2",
        label: "text-xs font-semibold uppercase tracking-wider text-gray-500",
        grid: "flex flex-wrap gap-2",
        swatch: "w-8 h-8 rounded-xl cursor-pointer transition-all duration-200 hover:scale-110 hover:shadow-md border-2 border-transparent",
        swatchActive: "w-8 h-8 rounded-xl cursor-pointer transition-all duration-200 scale-110 shadow-md ring-2 ring-offset-2 ring-gray-400",
    },
    emptyState: {
        container: "flex flex-col items-center justify-center h-[90vh] bg-gradient-to-br from-gray-50 via-violet-50/30 to-gray-50",
    },
};
